<template>
    <div
      class="">
      <v-layout wrap>
        <v-flex>
          <v-dialog v-model="dialog.detail"
            @keydown.esc="dialog.detail = false"
            :fullscreen="dialog.fullscreen"
            width="1000"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card-8'"
              class="pa-4 pt-3">
              <v-card-title 
                class="d-flex align-center pa-0 pb-2 text-right popup-header fs-16 font-weight-bold">
                
                Detail Invoice
  
                <v-spacer/>
                <v-icon 
                  @click="dialog.detail = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                <v-card 
                  flat
                  style="border-radius: 6px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    v-if="process.detail" 
                    class="pb-0 my-4" style="height: 300px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-2 title">
                        Mohon Tunggu...
                      </div>
                      <v-progress-circular
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-card-text>
                  <v-card-text v-if="!process.detail">
                    <v-row>
                      <v-col cols="12" md="6">
                        <table style="width: auto;" class="mb-2" v-if="!process.load">
                          <tr>
                            <td class="fs-12 pb-2">
                              No. Invoice
                            </td>
                            <td style="width: 40px" class="fs-12 pb-2 text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold fs-12 pb-2">
                              {{ detail.number }}
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-12 pb-2">
                              Nama Pemilik
                            </td>
                            <td style="width: 40px" class="fs-12 pb-2 text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold fs-12 pb-2">
                              <a target="_blank" :href="`/customer/data/detail/${detail.customer_id}`">
                                {{ detail.customer_name }}
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-12 pb-2">
                              Nama Toko
                            </td>
                            <td style="width: 40px" class="fs-12 pb-2 text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold fs-12 pb-2">
                              {{ detail.store_name }}
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-12 pb-2">
                              Kode Outlet
                            </td>
                            <td style="width: 40px" class="fs-12 pb-2 text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold fs-12 pb-2">
                              {{ customer_code }}
                            </td>
                          </tr>
                        </table>
                      </v-col>
                      <v-col cols="12" md="6">
                        <table style="width: auto;" class="mb-2" v-if="!process.load">
                          <tr>
                            <td class="fs-12 pb-2">
                              No. BPB
                            </td>
                            <td style="width: 40px" class="fs-12 pb-2 text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold fs-12 pb-2">
                              {{ detail.bpb_number }}
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-12 pb-2">
                              No. Order
                            </td>
                            <td style="width: 40px" class="fs-12 pb-2 text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold fs-12 pb-2">
                              {{ detail.orders_number }}
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-12 pb-2">
                              Status
                            </td>
                            <td style="width: 40px" class="fs-12 pb-2 text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold fs-12 pb-2">
                              {{ detail.status == 'belum lunas' ? 'Belum Lunas' : detail.status == 'lunas' ? 'Lunas' : detail.status == 'Set Order' ? 'Menunggu Pengiriman' : '-' }}
                            </td>
                          </tr>
                        </table>
                      </v-col>

                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card 
                  flat
                  v-if="!process.detail"
                  class="mt-4"
                  style="border-radius: 6px; border: 1px solid #E7E7E7;">
                  <v-card-text v-if="Object.keys(order_list).length > 0">
                    <v-row>
                      <v-col cols="12" class="pt-0">
                        <div class="font-weight-bold fs-12">
                          Alamat Kirim :
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" class="pt-0">
                        <div>
                          <div class="fs-12 font-weight-bold">
                            {{ detail.store_name }}
                          </div>
                          <div class="text-lowercase fs-12">
                            {{ detail.customer_address }}, kel. {{ detail.customer_village_name }}, kec. {{ detail.customer_subdistrict_name }}
                            Kab. {{ detail.customer_city_name }} - {{ detail.customer_province_name }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex justify-end pt-0">
                        <div>
                          <table style="width: 100%;">
                            <tr>
                              <td class="fs-12 font-weight-bold">
                                Nomer Order
                              </td>
                              <td style="width: 80px" class="fs-12 text-center">
                                : 
                              </td>
                              <td class="fs-12 text-right">
                                {{ detail.orders_number }}
                              </td>
                            </tr>
                            <tr>
                              <td class="fs-12 font-weight-bold">
                                Nomer Surat Jalan
                              </td>
                              <td style="width: 80px" class="fs-12 text-center">
                                : 
                              </td>
                              <td class="fs-12 text-right">
                                <a target="_blank" :href="`/delivery/surat-jalan/code-detail/${detail.delivery_number}`">
                                  {{ detail.delivery_number }}
                                </a>
                              </td>
                            </tr>
                            <tr>
                              <td class="fs-12 font-weight-bold">
                                Tanggal Order
                              </td>
                              <td style="width: 80px" class="fs-12 text-center">
                                :
                              </td>
                              <td class="fs-12 text-right">
                                {{ order_list.input_datetime | datetime }}
                              </td>
                            </tr>
                            <tr>
                              <td class="fs-12 font-weight-bold">
                                Tanggal Jatuh Tempo
                              </td>
                              <td style="width: 80px" class="fs-12 text-center">
                                :
                              </td>
                              <td class="fs-12 text-right">
                                {{ detail.due_date | date }}
                              </td>
                            </tr>
                          </table>
                        </div>
                      </v-col>
                      <v-col cols="12" class="my-8">
                        <div style="overflow: auto; ">
                          <table style="width: 100%;">
                            <tr>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="fs-12 font-weight-bold text-center">
                                Kode Barang
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="fs-12 font-weight-bold text-center">
                                Nama Barang
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="fs-12 font-weight-bold text-center">
                                Quantity
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="fs-12 font-weight-bold text-center">
                                Harga Per Unit
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="fs-12 font-weight-bold text-center">
                                Harga Bruto
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="fs-12 font-weight-bold text-center">
                                Diskon Promo
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="fs-12 font-weight-bold text-center">
                                Diskon Strata
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="fs-12 font-weight-bold text-center">
                                Harga Net. 
                              </td>
                            </tr>
                            <tr v-for="(item, index) in order_list.detail" :key="index">
                              <td style="border: 1px solid #ededed; padding: 10px;" class="fs-12 ">
                                {{ item.detail_varian_sku }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="fs-12 ">
                                {{ item.detail_varian_name }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="fs-12 ">
                                <!-- {{ `${item.bpb_detail_qty_dus_diterima*1}.${item.bpb_detail_qty_lusin_diterima*1}.${item.bpb_detail_qty_pcs_diterima*1}` }} -->

                                {{ `${(item.detail_total_in_dus*1) === 1 ? 0 : (item.bpb_detail_qty_dus_diterima*1)}.${item.bpb_detail_qty_lusin_diterima*1}.${(item.detail_total_in_dus*1) === 1 ? (item.bpb_detail_qty_dus_diterima*1) : (item.bpb_detail_qty_pcs_diterima*1)}` }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="fs-12 text-right">
                                <!-- Rp {{ item.detail_price_per_pcs | number_dec }}  -->
                                <span v-if="item.detail_qty_pcs !== 0">
                                  Rp. {{ item.detail_price_per_pcs | number_dec }}
                                </span>
                                <span v-else-if="item.detail_qty_lusin !== 0">
                                  Rp. {{ (item.detail_price_per_pcs*12) | number_dec }}
                                </span>
                                <span v-else-if="item.detail_qty_dus !== 0">
                                  Rp. {{ Math.round(item.detail_price_per_pcs*item.detail_total_in_dus) | number_dec }}
                                </span>
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="fs-12 text-right">
                                <!-- <span v-if="item.detail_qty_pcs !== 0">{{ item.detail_price_pcs | price }}</span>
                                <span v-else-if="item.detail_qty_lusin !== 0">{{ item.detail_price_lusin | price }}</span>
                                <span v-else-if="item.bpb_detail_qty_dus_diterima !== 0">{{ item.detail_price_dus_new | price }}</span> -->
                                {{ ((item.bpb_detail_qty_dus_diterima*1) === 0 ? 0 : (item.detail_price_dus_new*1)) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1) | price }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="fs-12 text-center">
                                {{ (((item.detail_discount*1))) | price }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="fs-12 text-center">
                                {{ (((item.detail_strata_nominal*1)*(item.bpb_detail_qty_dus_diterima*1))) | price }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="fs-12 text-right">
                                {{ ((((item.bpb_detail_qty_dus_diterima*1) === 0 ? 0 : (item.detail_price_dus_new*1)) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1)) - ((((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.bpb_detail_qty_dus_diterima*1))))) | price }}
                              </td>
                            </tr>
                          </table>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex justify-end pt-0">
                        <div class="fs-15">
                          <table style="width: 100%;">
                            <tr>
                              <td class="fs-12 pa-2 font-weight-bold">
                                Harga Bruto
                              </td>
                              <td style="width: 80px" class="fs-12 pa-2 text-center">
                                : 
                              </td>
                              <td class="fs-12 pa-2 text-right">
                                {{ order_list.detail.reduce((acc, item) => acc + ((((item.bpb_detail_qty_dus_diterima*1) === 0 ? 0 : (item.detail_price_dus_new*1)) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1))), 0) | price }}
                              </td>
                            </tr>
                            <tr>
                              <td class="fs-12 pa-2 font-weight-bold">
                                Diskon 
                              </td>
                              <td style="width: 80px" class="fs-12 pa-2 text-center">
                                :
                              </td>
                              <td class="fs-12 pa-2 text-right">
                                <!-- {{ order_list.total_discount*1 | price }} -->
                                  {{ order_list.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.bpb_detail_qty_dus_diterima*1))), 0) | price }}
                              </td>
                            </tr>
                            <!-- <tr>
                              <td class="fs-12 pa-2 font-weight-bold">
                                PPN 11%
                              </td>
                              <td style="width: 80px" class="fs-12 pa-2 text-center">
                                : 
                              </td>
                              <td class="fs-12 pa-2 text-right">
                                {{ detail.sales_name }}
                              </td>
                            </tr> -->
                            <tr>
                              <td class="fs-12 pa-2 font-weight-bold">
                                Harga Net
                              </td>
                              <td style="width: 80px" class="fs-12 pa-2 text-center">
                                :
                              </td>
                              <td class="fs-12 pa-2 text-right">
                                {{ ((order_list.detail.reduce((acc, item) => acc + ((((item.bpb_detail_qty_dus_diterima*1) === 0 ? 0 : (item.detail_price_dus_new*1)) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1))), 0)) - (order_list.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.bpb_detail_qty_dus_diterima*1))), 0))) | price }}
                              </td>
                            </tr>
    
                          </table>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card-text>
  
  
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
                <v-btn
                  rounded
                  width="120"
                  @click="dialog.detail = false; dialog.fullscreen = false;"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Tutup
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <section>
            <v-card 
              flat
              class="ma-4 mt-0 box-shadow pb-5"
              style="border-radius: 10px;">
  
              <v-row
                class="pa-4 py-0">
                <v-col
                  cols="12"
                  class="pb-0"
                  md="7">
                  <span
                    class="fs-16 black--text"
                    style="font-weight: 600;">
                    Detail Kartu Piutang
                  </span>
                  <!-- <div
                    class="body-2">
                    Perbandingan SP2D 
  
                    <span v-if="filter.year !== '' && filter.year !== null">
                      tahun <strong class="black--text">{{ filter.year }}</strong>
                    </span>
  
                    <span v-if="filter.month !== '' && filter.month !== null">
                      di bulan <strong class="black--text">{{ filter.month_text }}</strong>
                    </span>
                  </div> -->
                </v-col>
                <!-- <v-col cols="12">
                  <div>
                    <v-tabs
                      v-model="tabs"
                      dense
                      background-color="transparent"
                      slider-size="5"
                      v-on:change="fetch()"
                      color="#1814F3">
                      <v-tab
                        v-for="(item, index) in tab"
                        :key="index">
                        <span
                          class="body-2 font-weight-medium text-capitalize">
                          {{ item.title }}
                        </span>
                      </v-tab>
                    </v-tabs>
                    <v-divider style="border-color: #EBEEF2;"></v-divider>
                  </div>
                </v-col> -->
                <v-col
                  cols="12"
                  md="12"
                  class="d-flex align-center py-0">
                  <v-row>
                    <v-col cols="12" md="6">
                      <table style="width: auto;" class="mb-2" v-if="!process.load">
                        <tr>
                          <td class="fs-12">
                            Kode Konsumen
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            {{ detailCustomer.customer_code }}
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-12">
                            Nama Toko
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            {{ detailCustomer.store[0].store_name }}
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-12">
                            Nama Pemilik
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            {{ detailCustomer.name }}
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-12">
                            Alamat Toko
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            {{ detailCustomer.store[0].store_address }}
                          </td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="6">
                      <table style="width: auto;" class="mb-2" v-if="!process.load">
                        <tr>
                          <td class="fs-12">
                            Plafond
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            {{ (detailCustomer.plafon*1) | price }}
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-12">
                            Term Of Payment
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            {{ detailCustomer.term }} Hari
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-12">
                            Kode/ Nama Sales
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            <div v-if="list.length > 0">
                              {{ list[0].sales_region_name }} / {{ list[0].sales_name }}
                            </div>
                            <div v-else>
                              -
                            </div>
                          </td>
                        </tr>
                      </table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
  
              <v-card 
                flat
                class="mt-0 mx-5"
                style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <!-- :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '148px'})`" -->
                <div class="view">
                  <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper-laporan-faktur'">
                    <table style="border-radius: 10px; width: 100%;" class="table">
                      <tr>
                        <th class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">
                          Aksi
                        </th>
                        <th class="sticky-col second-col-detail-faktur" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">
                          Tanggal Piutang
                          <span v-if="sortBy === 'customer_code'">
                            <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">
                          No. Piutang
                        </th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">Tgl Pembayaran</th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: right;">
                          nilai pembayaran
                        </th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: right;">
                          Sisa Piutang
                        </th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">
                          Umur Piutang
                        </th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">
                          Status Invoice
                        </th>
                        <!-- <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;"></th> -->
                        <!-- <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Realisasi</th>
                        <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Selisih</th> -->
                      </tr>
                      <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                        <td class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">
                          <div v-if="item.status !== 'lunas'">
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  :href="`/kasir/customer/detail/${item.id}`"
                                  target="_blank"
                                  v-bind="attrs"
                                  v-on="on"
                                  
                                  min-width="28"
                                  small
                                  rounded
                                  color="green"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-information-outline</v-icon>
                                </v-btn>
                              </template>
        
                              <span>Detail Invoice Customer</span>
                            </v-tooltip>
                          </div>
                        </td>
                        <td class="sticky-col second-col-detail-faktur" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 180px; min-width: 180px; max-width: 180px; padding: 8px 12px; text-align: center;">
                          {{ item.input_datetime | datetime }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">
                          <div class="blue--text" style="cursor: pointer" @click="dialog.detail = true; fetchDetail(item.id); customer_code = item.customer_code">
                            {{ item.number }}
                          </div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">
                          {{ item.paid_date | date }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: right;">
                          <!-- {{ item.total*1 | price }} -->
                          {{ (((item.orders_detail.reduce((sum, k) => sum + ((Math.round((k.price_per_pcs*1) * (k.total_in_dus*1)) * (k.qty_dus_diterima*1))), 0))) - item.orders_detail.reduce((sum, i) => sum + (i.discount*1), 0) - item.orders_detail.reduce((sum, i) => sum + ((i.strata_nominal*1) * (i.qty_dus_diterima*1)), 0)) | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: right;">
                          <div v-if="item.paid_date !== ''">
                            0
                          </div>
                          <div v-else>
                            {{ ((((item.orders_detail.reduce((sum, k) => sum + ((Math.round((k.price_per_pcs*1) * (k.total_in_dus*1)) * (k.qty_dus_diterima*1))), 0))) - item.orders_detail.reduce((sum, i) => sum + (i.discount*1), 0) - item.orders_detail.reduce((sum, i) => sum + ((i.strata_nominal*1) * (i.qty_dus_diterima*1)), 0)) - (item.total_paid*1)) | price }}
                          </div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">
                          <div v-if="item.paid_date !== ''">
                            {{ Math.floor((new Date(item.paid_date).setHours(0,0,0,0) - new Date(item.input_datetime).setHours(0,0,0,0)) / (1000 * 60 * 60 * 24)) }} hari
                          </div>
                          <div v-else>
                            <!-- {{ Math.floor((new Date() - new Date(item.input_datetime)) / (1000 * 60 * 60 * 24)) }} hari -->
                            {{ Math.floor((new Date().setHours(0,0,0,0) - new Date(item.input_datetime).setHours(0,0,0,0)) / (1000 * 60 * 60 * 24)) }} hari
                          </div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left; text-transform: capitalize;">
                          {{ item.status | status }}
                        </td>
                        <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">{{ (item.realisasi*1) | price }}</td> -->
                        <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">
                          {{ ((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' :((item.nominal*1) + (item.nominal_sp2b*1)) > (item.realisasi*1) ? '-' : '+'}}
                          {{ (((item.nominal*1) + (item.nominal_sp2b*1)) - (item.realisasi*1)) | price }}
                        </td> -->
                      </tr>
                    </table>
                  </div>
  
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
  
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>
  
                  <v-card-text
                    v-if="list.length === 0"
                    class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                        <!-- <template v-slot:placeholder>
                          <v-row
                            class=" "
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template> -->
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum Ada Data
                      </div>
                    </div>
                  </v-card-text>
                </div>
  
  
                <!-- <pagination v-if="pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination"/> -->
              </v-card>
            </v-card>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      props: {
        detailCustomer: {
          type: Object,
          default: {}
        }
      },
      data () {
        return {
          checkbox: false,
          tabs: 0,
          tab: [
            {
              title: 'Belum Lunas',
              id: 'belum lunas'
            },
  
            {
                title: 'Pengajuan',
                id: 'pengajuan'
              },
            {
              title: 'Lunas',
              id: 'lunas'
            },
          ],
          filterDataToko: '',
  
          dialog: {
            fullscreen: false,
            snackbar: false,
            freeze: false,
            hide: false,
  
            filter: false,
  
            form: false,
            delete: false,
            detail: false
          },
          
          search: '',
  
          filter: {
            year: new Date().getFullYear()
          },
          sortBy: 'id',
          sortDesc: '-',
  
          selected: {
            freeze: [],
            delete: [],
            row: [],
            export: '',
            invoice: []
          },
  
          sales: [],
  
          form: {
            id: '',
            sales_id: '',
            name_alias: '',
            name: '',
            mobilephone: '',
            address: '',
            pic_name: '',
            email: '',
            nik: '',
            npwp: '',
            plafon: '',
            faktur: '',
            term: '',
            ttd: '',
            invoice_total: 0
          },
  
          options: {},
          headers: [],
          list: [],
          pagination: {},
          paginationList: {},
          toko: [],

          detail: {},
          order_list: {},
          customer_code: '',
  
          lastIndex: 0,
          limit: 50,
  
          process: {
            load: false,
            delete: false,
            export: false,
            form: false,
            detail: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
          pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
      },
      watch: {
        // 'options': {
        //   handler () {
        //     let pagination = { row: this.limit, page: 1 }
            
        //     this.fetch(pagination)
        //   },
        //   deep: true
        // }
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        user () {
          return this.$store.state.user
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        },
  
        years () {
          let max = new Date().getFullYear()+2, min = max - 2, years = []
  
          for (let i = max; i >= min; i--) {
            years.push({
              text: i,
              value: i
            })
          }
  
          return years
        }
      },
      mounted () {
        this.fetchEditToko()
        this.fetch()
      },
      methods: {
        async fetchEditToko() {
          
          this.toko = []
          let params = {
            pagination_bool: false,
            status: 'approved'
            // id: this.form.customer_id
          }
    
          await get('admin/toko/data', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.toko = res.results.data
            }
          })
        },
        toSort(name) {
          this.sortBy = name
          this.sortDesc = ''
          this.fetch()
        },
        toDesc() {
          this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
          this.fetch()
        },
        rowFormat (format, value) {
          let data = value
  
          if (format === 'number') {
            if (isNaN(value)) return 'Not a Number'
            let price = ''
  
            const reverseNumber = (value*1)
              .toString()
              .split('')
              .reverse()
              .join('')
            const arrReverseNumber = [...Array(reverseNumber.length).keys()]
  
            arrReverseNumber.map(index => {
              if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
            })
  
            return `Rp ${
              price.split('', price.length - 1)
              .reverse()
              .join('')
            }`
          } else if (format === 'array') {
            let arr = []
  
            for (let i = 0; i < value.length; i++) {
              arr.push(value[i].label)
            }
  
            data = arr.join(', ')
          } else if (format === 'date') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
          } else if (format === 'time') {
            data = value.length > 0 ? moment(value).format('HH:mm') : '-'
          } else if (format === 'datetime') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          } else if (format === 'object') {
            data = value.createdby.name
          } else if (format === 'regex') {
            // let regex = /(<([^>]+)>)/ig
  
            // data = value.replace(regex, '')
          } else if (format === 'underscore') {
            let regex = /_/g
  
            data = value.replace(regex, ' ')
          } else if (format === 'on_off') {
            data = value ? 'Online' : 'Offline'
          } else if (format === 'g_m') {
            data = value ? 'Mandiri' : 'Group'
          } else if (format === 'v_a') {
            data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
          } else if (format === 'y_n') {
            data = parseInt(value) ? 'Ya' : 'Tidak'
          } else if (format === 'percent') {
            data = Number(value) + ' %'
          } else if (format === 'action') {
            data = value
          } else if (format === 'bool') {
            data = value
          } else if (format === 'status') {
            data = value
          } else if (format === 'link') {
            data = value
          }  else {
            data = value ? 'Aktif' : 'Tidak Aktif'
          }
  
          return data
        },
  
        async fetch (pagination = { row: 50, page: 1 }) {
          this.process.load = true
  
          this.limit = pagination.row
          this.paginationList = pagination
  
          let params = {
            // status: this.tab[this.tabs].id,
            limit: 100000000,
            search: this.search,
            customer_id: this.$route.params.id,
            sort: '-id',
          }
  
          this.selected.row = []
  
          // admin/services/data
          
          await get(`admin/customer_invoice/data`, { params })
          .then(response => {
            let res = response.data
            
            this.process.load = false
            
            this.list = []
            this.pagination = {}
            
            if (res.status === 200) {
              this.headers = [
                {
                  text: '',
                  width: '80px',
                  value: 'id',
                  freeze: true,
                  hide: false,
                  align: 'start',
                  format: 'action'
                },
                {
                  text: 'No',
                  width: '80',
                  value: 'index',
                  freeze: true,
                  hide: false
                },
                {
                  text: 'No. Invoice',
                  width: '200px',
                  value: 'number',
                  freeze: true,
                  hide: false
                },
                {
                  text: 'No. BPB',
                  width: '180px',
                  value: 'bpb_number',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Total Tagihan',
                  width: '200px',
                  value: 'sub_total',
                  freeze: false,
                  hide: false,
                  format: 'number'
                },
                // {
                //   text: 'Biaya Pengiriman',
                //   width: '200px',
                //   value: 'biaya_kirim',
                //   freeze: false,
                //   hide: false,
                //   format: 'number'
                // },
                {
                  text: 'Tanggal Jatuh Tempo',
                  width: '250px',
                  value: 'due_date',
                  freeze: false,
                  hide: false,
                  format: 'date'
                },
                // {
                //   text: 'Status',
                //   width: '150px',
                //   value: 'status',
                //   freeze: false,
                //   hide: false,
                //   format: 'status'
                // },
                // {
                //   text: 'No. BPB',
                //   width: '180px',
                //   value: 'bpb_number',
                //   freeze: false,
                //   hide: false
                // }
              
              ]
      
              this.list = res.results.data
              this.pagination = res.results.pagination
  
              // this.list.map(obj => {
              //   obj.is_active = obj.is_active === 'Aktif' ? true : false
              // })
  
              this.lastIndex = (pagination.page - 1) * pagination.row 
              this.lastIndex += 1
  
  
              // this.addFreezes()
  
              // this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper-laporan-faktur') })
  
              // if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            }
          })
        },

        async fetchDetail (id_invoice) {
          this.process.detail = true
          let params = {
            id: id_invoice
          }

          await get('admin/customer_invoice/detail', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.form.bpb_arr = []
              this.detail = res.results.data
              this.fetchDetailOrder(this.detail.orders_id)
            }
            this.process.load = false
          })
        },


        async fetchDetailOrder (id) {
          this.process.load = true
          let params = {
            id: id,
            bpb_id: this.detail.bpb_id ? this.detail.bpb_id : ''
          }

          await get('admin/order/detail', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              let data_detail = []
              res.results.data.detail.map((item, index) => {
                data_detail.push(
                  {
                    ...item,
                    detail_price_dus_new: (Math.round(item.detail_price_per_pcs*item.detail_total_in_dus)*(item.bpb_detail_qty_dus_diterima*1))
                  }
                )
              })
              this.order_list = res.results.data
              this.order_list.detail = data_detail
            }
            this.process.detail = false
          })
        },
  
  
        addFreezes () {
          this.removeFreezes()
  
          this.selected.freeze = []
  
          for (let i = 0; i < this.configHeaders.length; i++) {
            if (this.configHeaders[i].freeze) {
              // ADD TO SELECTOR
              this.selected.freeze.push({
                child: i + (this.checkbox ? 2 : 1),
                width: this.configHeaders[i].width.split('px')[0]
              })
  
              // LOOP STYLESHEET
              for (let f = 0; f < this.selected.freeze.length; f++) {
                let style = document.createElement('style'),
                    width = 0
  
                if (this.checkbox) {
                  width = f < 1 ? '65' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
                } else {
                  width = f < 1 ? '0' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
                }
  
                // ADD STYLESHET TO FREEZE
                style.innerHTML = `
                  .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 5;
                    background: #FFFFFF;
                  }
  
                  .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 1;
                  }
                `
  
                // ADD TO APPENDCHILD
                document.head.appendChild(style)
              }
            }
          }
        },
        removeFreezes () {
          // LOOP STYLESHEET
          for (let f = 0; f < this.selected.freeze.length; f++) {
            let style = document.createElement('style')
            
            // RESET STYLESHEET TO AUTO
            style.innerHTML = `
              .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
                background: #FFFFFF;
              }
  
              .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
              }
            `
  
            // ADD TO APPENDCHILD
            document.head.appendChild(style)
          }
        },
        addHides () {
          if (this.headers.length < 6) this.getTableToResize()
        },
        getTableToResize () {
          let tables = document.getElementsByTagName('table')
  
          for (let i = 0; i < tables.length; i++) {
            this.resizableGrid(tables[i])
          }
        },
        resizableGrid (table) {
          let row = table.getElementsByTagName('tr')[0],
              cols = row ? row.children : undefined
          
          if (!cols) return
          
          table.style.overflow = 'hidden'
          
          let tableHeight = table.offsetHeight
          
          for (let i = 0; i < cols.length; i++) {
            let div = createDiv(tableHeight)
            cols[i].appendChild(div)
            cols[i].style.position = 'relative'
  
            setListeners(div)
          }
  
          function setListeners (div) {
            let pageX, curCol, nxtCol, curColWidth, nxtColWidth
  
            div.addEventListener('mousedown', e => {
              curCol = e.target.parentElement
              nxtCol = curCol.nextElementSibling
              pageX = e.pageX
              
              let padding = paddingDiff(curCol)
              
              curColWidth = curCol.offsetWidth - padding
  
              if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
            })
  
            div.addEventListener ('mouseover', e => {
              e.target.style.borderRight = '2px solid #e0e0e0'
            })
  
            div.addEventListener ('mouseout', e => {
              e.target.style.borderRight = ''
            })
  
            document.addEventListener ('mousemove', e => {
              if (curCol) {
                let diffX = e.pageX - pageX
            
                if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'
  
                curCol.style.width = (curColWidth + diffX)+'px'
              }
            })
  
            document.addEventListener ('mouseup', () => { 
              curCol = undefined
              nxtCol = undefined
              pageX = undefined
              nxtColWidth = undefined
              curColWidth = undefined
            })
          }
  
          function createDiv (height) {
            let div = document.createElement('div')
  
            div.style.top = 0
            div.style.right = 0
            div.style.width = '1px'
            div.style.position = 'absolute'
            div.style.cursor = 'col-resize'
            div.style.userSelect = 'none'
            div.style.height = height + 'px'
            div.style.background = '#e0e0e0'
  
            return div
          }
  
          function paddingDiff (col) {
            if (getStyleVal(col,'box-sizing') == 'border-box') {
              return 0
            }
            
            let padLeft = getStyleVal(col,'padding-left')
            let padRight = getStyleVal(col,'padding-right')
  
            return (parseInt(padLeft) + parseInt(padRight))
          }
  
          function getStyleVal (elm,css) {
            return (window.getComputedStyle(elm, null).getPropertyValue(css))
          }
        },
      }
    }
  </script>
  
  <style>
    /* ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      background-color: #F5F5F5;
    }
    ::-webkit-scrollbar-track{
      background-color: #F5F5F5;
      border-radius: 10px;
    } */
    ::-webkit-scrollbar-thumb{
      border-radius: 10px;
      background-color: #718EBF;
    }
    table, th, td {
      /* border: 1px solid #ededed;
      border-collapse: collapse; */
      /* border: thin ridge black; */
      border-spacing: 4px;
      border-collapse: collapse;
    }
  
    .view {
      margin: auto;
      /* width: 100%; */
    }
  
    .wrapper-laporan-faktur { 
      overflow-y: auto; 
      height: calc(100vh - 290px); 
    } 
  
    .wrapper-laporan-faktur-none { 
      /* overflow-y: auto; 
      height: calc(100vh - 270px);  */
    } 
  
    .wrapper-laporan-faktur th { 
      position: sticky; 
      top: 0; 
      background-color: white !important;
    } 
    .sticky-col {
      position: -webkit-sticky;
      position: sticky;
      background-color: white !important;
    }
  
    .one-col {
      width: 60px;
      min-width: 60px;
      max-width: 60px;
      left: 0px;
    }
  
    .second-col-detail-faktur {
      width: 100px;
      min-width: 100px;
      max-width: 100px;
      left: 60px;
    }
  
    .three-col {
      width: 150px;
      min-width: 150px;
      max-width: 150px;
      left: 300px;
    }
  
    .four-col {
      width: 200px;
      min-width: 200px;
      max-width: 200px;
      left: 450px;
    }
  
    tr:hover {background-color: #1976d236;}
    tr.selected {background-color: #1976d236;}
  
    .border-radius-card-8 {
      border-radius: 8px;
    }
  </style>